import React from "react";

const AgentsActiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="31"
      viewBox="0 0 34 31"
      fill="none"
    >
      <circle
        cx="7.28592"
        cy="5"
        r="4"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2859 11L19.7859 5L32.2859 13.1818V14.5455H28.9918V30H10.2859"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2859 11H3.28592L1.28592 22H4.78592V30H10.2859V21.5H13.2859L11.2859 11Z"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.28592 11V17"
        stroke="#ffffff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AgentsActiveIcon;
